var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 16.6666V15C3.33325 14.1159 3.68444 13.2681 4.30956 12.6429C4.93468 12.0178 5.78253 11.6666 6.66658 11.6666H8.74992M14.1674 16.6666C13.7254 16.6666 13.3015 16.491 12.9889 16.1785C12.6764 15.8659 12.5008 15.442 12.5008 15C12.5008 14.5579 12.6764 14.134 12.9889 13.8214C13.3015 13.5089 13.7254 13.3333 14.1674 13.3333M14.1674 16.6666C14.6095 16.6666 15.0334 16.491 15.3459 16.1785C15.6585 15.8659 15.8341 15.442 15.8341 15C15.8341 14.5579 15.6585 14.134 15.3459 13.8214C15.0334 13.5089 14.6095 13.3333 14.1674 13.3333M14.1674 16.6666V17.9166M14.1674 13.3333V12.0833M16.6933 13.5416L15.6108 14.1666M12.7249 15.8333L11.6416 16.4583M11.6416 13.5416L12.7249 14.1666M15.6108 15.8333L16.6941 16.4583M4.99992 4.99996C4.99992 5.88401 5.35111 6.73186 5.97623 7.35698C6.60135 7.9821 7.4492 8.33329 8.33325 8.33329C9.21731 8.33329 10.0652 7.9821 10.6903 7.35698C11.3154 6.73186 11.6666 5.88401 11.6666 4.99996C11.6666 4.1159 11.3154 3.26806 10.6903 2.64294C10.0652 2.01782 9.21731 1.66663 8.33325 1.66663C7.4492 1.66663 6.60135 2.01782 5.97623 2.64294C5.35111 3.26806 4.99992 4.1159 4.99992 4.99996Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCog);
export default __webpack_public_path__ + "static/media/userCog.93383d5234268445ae8fcce16fa74551.svg";
export { ForwardRef as ReactComponent };